import { createSelector } from 'reselect';
import { RootState } from 'store/types';

export const socialHistorySelector = (state: RootState) => state.socialHistory.socialHistory;

export const socialHistoryLoadingSelector = createSelector(
  socialHistorySelector,
  socialHistory => socialHistory.loading
);

export const socialHistoryDataSelector = createSelector(socialHistorySelector, socialHistory => {
  const { data } = socialHistory;
  const socialHistoryObject = data && Array.isArray(data) && data.length === 1 ? data[0] : data;

  // expansion entities for social history
  // include an 'adapterSource' property that is not an array
  if (Object.hasOwnProperty.call(socialHistoryObject, 'adapterSource')) {
    /* @ts-expect-error: adapterSource does exist */
    const { adapterSource, ...socialHistoryArrays } = socialHistoryObject;
    return socialHistoryArrays;
  }

  return socialHistoryObject;
});

export const socialHistoryDataByCategorySelector = createSelector(
  socialHistoryDataSelector,
  socialHistory => {
    const data = Object.keys(socialHistory)
      .map((title: string) => ({
        category: title,
        socialHistory: socialHistory[title]
      }))
      .filter(item => item.socialHistory.length > 0);

    return data;
  }
);

export const socialHistoryDataArraySelector = createSelector(
  socialHistoryDataSelector,
  socialHistory => {
    return Object.values(socialHistory).flat();
  }
);

export const socialHistoryErrorSelector = createSelector(
  socialHistorySelector,
  socialHistory => socialHistory.error
);

export const socialHistoryRequestStateSelector = createSelector(
  socialHistorySelector,
  socialHistory => socialHistory.requestState
);

/**
 * Share Social History
 */
export const shareSocialHistorySelector = (state: RootState) =>
  state.socialHistory.shareSocialHistory;

export const shareSocialHistorySendingSelector = createSelector(
  shareSocialHistorySelector,
  shareSocialHistory => shareSocialHistory.isSendingSocialHistory
);

export const shareSocialHistoryDataSelector = createSelector(
  shareSocialHistorySelector,
  shareSocialHistory => shareSocialHistory.sharedSocialHistoryData
);

/**
 * Download Social History
 */
export const socialHistoryDownloadsSelector = (state: RootState) =>
  state.socialHistory.downloadSocialHistory;

export const socialHistoryDownloadingSelector = createSelector(
  socialHistoryDownloadsSelector,
  downloadSocialHistory => downloadSocialHistory.isDownloading
);
